'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import Pager from 'shared/components/Pager';
import scrollToTop from 'shared/utils/scrollToTop';
import { Col, Container, ListGroup, Row } from 'reactstrap';
import { useRouter } from 'next/navigation';
import JobTeaser from 'shared/components/JobTeaser';
import { getI18nUtils } from 'shared/i18n/i18n-utils';
import ContentRow from './ContentRow';
import ContentSection from './ContentSection';
import CompanyVideo from './CompanyVideo';
import { Dictionaries } from '../i18n/i18n-config';

type Props = {
  dictionary: Partial<Dictionaries>;
  company: any;
  jobs: Job[];
  count: number;
  totalPages: number;
  page: number;
  locale: string;
};
function Companies({ dictionary, company, jobs, count, totalPages, page, locale }: Props) {
  const { push } = useRouter();
  const { formatMessage } = getI18nUtils(dictionary);
  const { id, headerImage, logo, title, description, body, uri, youtubeId, video } = company;

  const handlePageChange = (newPage) => {
    const newUrl = `/${locale}/${uri}?page=${newPage}`;
    push(newUrl);
    const companyContainer = document.getElementById('companyJobs');
    if (companyContainer) {
      const companyOffset = companyContainer.offsetTop;
      scrollToTop(companyOffset);
    }
  };
  const firstJob = page * 10 - 9;
  const lastJob = page * 10 > count ? count : page * 10;

  let header = !!headerImage;
  if (process.env.NEXT_PUBLIC_APP === 'sandyou.be') header = true;

  let videoId;
  if (video && video.videoId) videoId = video.videoId;
  else if (youtubeId) videoId = youtubeId;

  return (
    <Container>
      <Row className="mb-5">
        <Col className={`companyLogoContainer ${header ? 'header' : 'noheader'} `} lg={4}>
          <img className="companyLogo img-fluid" src={logo} alt={`${title}-logo`} />
          {videoId && <CompanyVideo videoId={videoId} source={video?.source} className="youtubeContainer mt-5" />}
        </Col>

        <Col
          xs={12}
          lg={{ size: 7, offset: 1 }}
          id="companyInfo"
          // className={`${headerImage ? '' : 'withMargin'}`}
        >
          {/* On sandyou.be the company name is the hero <h1>, so demote this one to <h2> to avoid a duplicate page heading. */}
          {process.env.NEXT_PUBLIC_APP === 'sandyou.be' ? <h2 className="mb-3">{title}</h2> : <h1 className="mb-3">{title}</h1>}
          <div className="companyDescription" dangerouslySetInnerHTML={{ __html: description }} />
        </Col>
        <Col className="h-100 d-flex justify-content-center align-items-center flex-column" md={4}>
          {videoId && <CompanyVideo videoId={videoId} source={video?.source} className="youtubeContainerMobile mt-5" />}
        </Col>
      </Row>
      {body && (
        <Container>
          <ContentRow>
            {body.map((section, index) => (
              <ContentSection
                dictionary={dictionary}
                key={`section-${index}`}
                className="py-4"
                section={section}
                id={id}
                source="landingPage"
              />
            ))}
          </ContentRow>
        </Container>
      )}
      <Row id="companyJobs">
        <Col md={12}>
          <h2 className="mb-4">
            {firstJob} - {lastJob} {formatMessage({ id: 'of' })} <strong>{count}</strong>{' '}
            {formatMessage({ id: 'company-detail-jobs-at' }, { company: title })}
          </h2>
          {jobs && (
            <ListGroup>
              {jobs.map((job) => (
                <JobTeaser job={job} key={job.id} titleTag="h3" dictionary={dictionary} />
              ))}
            </ListGroup>
          )}
          <Pager className="mt-3" currentPage={page} totalPages={totalPages} changePage={handlePageChange} />
        </Col>
      </Row>
    </Container>
  );
}

export default Companies;
